export enum Persona {
  CONSIGNEE                  = 1,
  ISO_TANK_DEPOT             = 2,
  LOGISTICS_SERVICE_PROVIDER = 3,
  PORT                       = 4,
  RAILHEAD                   = 5,
  SHIPPER                    = 6,
  SHIPPING_LINE              = 7,
  TRUCKING_COMPANY           = 8,
  AGENT                      = 10,
  BULK_STORAGE_TERMINAL      = 11,
  CARRIER                    = 12,
  FREIGHT_FORWARDER          = 13
}
